import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { toastSuccess } from 'ui/partials/Toast';

import c from '../utils/constants';

export default function useUpdateNotificationStatus() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async (payload: { id: string; status: string }) => {
      const api = new Api(args);

      const data = await api.patch({
        url: `api/v1/notifications/${payload.id}/${payload.status}`,
        payload,
      });

      return data;
    },
    // get the variables from the mutation { id: string, status: c.NOTIFICATION_STATUS }
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [c.NOTIFICATIONS],
      });
      toastSuccess('Successfully updated notification');
    },
  });
}
